import * as React from "react";
import { Header } from "./Header";
import { useProjectDashboardPageStyles } from "../styles/projectDashboard.styles";
import illustrationSrc from "../assets/error-illustration.svg";

const mainContentStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    padding: "48px",
};

const innerStyle: React.CSSProperties = {
    display: "flex",
    gap: "24px",
    alignItems: "center",
    justifyContent: "center",
};

const illustrationStyle: React.CSSProperties = {
    width: "280px",
    height: "280px",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};

const illustrationImgStyle: React.CSSProperties = {
    width: "200px",
    height: "190px",
};

const textContentStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    gap: "32px",
    padding: "24px 0",
};

const headingStyle: React.CSSProperties = {
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    color: "white",
    lineHeight: "28px",
    margin: 0,
};

const sectionStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    width: "592px",
};

const sectionTitleStyle: React.CSSProperties = {
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: "16px",
    lineHeight: "22px",
    color: "#adadad",
    margin: 0,
};

const listStyle: React.CSSProperties = {
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: "16px",
    lineHeight: "22px",
    color: "#adadad",
    paddingLeft: "20px",
    margin: 0,
    listStyleType: "disc",
};

const linkStyle: React.CSSProperties = {
    color: "#479ef5",
    textDecoration: "underline",
};

const NoSubscriptionPage: React.FC = () => {
    const ds = useProjectDashboardPageStyles();

    return (
        <div className={ds.page}>
            <Header showAppTitle />
            <div style={mainContentStyle}>
                <div style={innerStyle}>
                    <div style={illustrationStyle}>
                        <img
                            src={illustrationSrc}
                            alt="No subscription"
                            style={illustrationImgStyle}
                        />
                    </div>
                    <div style={textContentStyle}>
                        <p style={headingStyle}>
                            We can't find any onboarded subscription for private preview.
                        </p>
                        <div style={sectionStyle}>
                            <p style={sectionTitleStyle}>
                                If you are onboarded for the private preview, you can try
                            </p>
                            <ul style={listStyle}>
                                <li>
                                    Follow the step-by-step instructions provided in the{" "}
                                    <a
                                        href="https://turbo-telegram-qjwo9wj.pages.github.io/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={linkStyle}
                                    >
                                        getting started guide
                                    </a>{" "}
                                    to start using your subscription
                                </li>
                                <li>
                                    To navigate to a different directory, simply access the user
                                    menu located in the top right corner of the screen and select
                                    the desired directory.
                                </li>
                            </ul>
                        </div>
                        <div style={sectionStyle}>
                            <p style={sectionTitleStyle}>
                                If you have not yet onboarded for the private preview,
                            </p>
                            <ul style={listStyle}>
                                <li>
                                    Please reach out to the{" "}
                                    <a
                                        href="mailto:testing-agent-devs@microsoft.com"
                                        style={linkStyle}
                                    >
                                        team
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NoSubscriptionPage;
